export class Page{
  pageNumber:number=0;
  pageSize:number=10;
  totalRecords:number=0;
}
